import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4487167e")

_pushScopeId("data-v-4487167e")
const _hoisted_1 = { class: "loading-indicator" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-spinner fa-spin fa-2x" })
], -1)
const _hoisted_3 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      (_ctx.showLoadingText)
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.loadingText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
})